/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CrawledStatus = "NoAccess" | "None" | "Pending" | "Stale" | "Synced" | "VeryStale" | "%future added value";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type ExcludedSlots = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type WorkingHoursTypeEnum = "Base" | "Meeting" | "PreferredFocusTime" | "%future added value";
export type ChromeDay_viewer = {
    readonly user: {
        readonly givenName: string | null;
        readonly emails: ReadonlyArray<string>;
        readonly id: string;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly experiments: ReadonlyArray<string | null> | null;
                    readonly primaryOrgEmail: string;
                    readonly eventColoringSettingsErrorable: {
                        readonly __typename: "EventColoringSettings";
                        readonly eventCategoryColorings: ReadonlyArray<{
                            readonly active: boolean;
                            readonly eventCategory: string;
                            readonly googleColorKey: string | null;
                            readonly isUserSet: boolean;
                        }> | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly userWorkingHours: {
                        readonly workingHours: {
                            readonly id: string;
                            readonly type: WorkingHoursTypeEnum | null;
                            readonly timeZone: string | null;
                            readonly daySettings: ReadonlyArray<{
                                readonly day: Day | null;
                                readonly setting: {
                                    readonly minSlot: MinSlot | null;
                                    readonly maxSlot: MaxSlot | null;
                                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                                } | null;
                            } | null> | null;
                            readonly dayOverrides: ReadonlyArray<{
                                readonly date: string | null;
                                readonly setting: {
                                    readonly minSlot: MinSlot | null;
                                    readonly maxSlot: MaxSlot | null;
                                    readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                                } | null;
                            } | null> | null;
                        } | null;
                    } | null;
                    readonly calendarTimeStatsList: ({
                        readonly __typename: "CalendarTimeStatsList";
                        readonly list: ReadonlyArray<{
                            readonly calendarId: string | null;
                            readonly scoresByDate: ReadonlyArray<{
                                readonly secondaryKey: string | null;
                                readonly busyMinutes: number | null;
                                readonly focusMinutes: number | null;
                                readonly totalMinutes: number | null;
                                readonly crawledStatus: CrawledStatus;
                            }>;
                        }>;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                    readonly eventParentBaseWrapperByWeeksObject: {
                        readonly __typename: "EventParentBaseWrapperByWeekObjectList";
                        readonly list: ReadonlyArray<{
                            readonly eventParentBases: ReadonlyArray<{
                                readonly id: string;
                                readonly timestamp: unknown;
                            }>;
                            readonly eventParentsByDay: ReadonlyArray<{
                                readonly eventParents: ReadonlyArray<{
                                    readonly id: string;
                                    readonly eventParentBaseId: string | null;
                                    readonly eventParentBaseTimestamp: unknown | null;
                                    readonly events: ReadonlyArray<{
                                        readonly title: string | null;
                                        readonly locked: boolean | null;
                                        readonly isClockwiseEvent: boolean;
                                        readonly isAllDay: boolean | null;
                                        readonly calendarIds: ReadonlyArray<string>;
                                        readonly organizer: {
                                            readonly urnValue: string;
                                            readonly responseStatus: ResponseStatusEnum | null;
                                        } | null;
                                        readonly attendees: ReadonlyArray<{
                                            readonly urnValue: string;
                                            readonly responseStatus: ResponseStatusEnum | null;
                                        }>;
                                        readonly creator: {
                                            readonly urnValue: string;
                                        } | null;
                                        readonly annotatedEvent: {
                                            readonly userTags: ReadonlyArray<{
                                                readonly tag: string;
                                                readonly states: ReadonlyArray<{
                                                    readonly subjectType: SubjectUrnTypeEnum;
                                                    readonly subjectValue: string;
                                                    readonly value: string | null;
                                                }> | null;
                                            }> | null;
                                            readonly orgTags: ReadonlyArray<{
                                                readonly tag: string;
                                                readonly state: {
                                                    readonly subjectType: SubjectUrnTypeEnum;
                                                    readonly subjectValue: string;
                                                    readonly value: string | null;
                                                };
                                            }> | null;
                                        } | null;
                                        readonly eventKey: {
                                            readonly externalEventId: string;
                                        };
                                        readonly location: string | null;
                                        readonly startTime: {
                                            readonly dateOrDateTime: string;
                                            readonly millis: number;
                                        };
                                        readonly endTime: {
                                            readonly dateOrDateTime: string;
                                            readonly millis: number;
                                        };
                                    }>;
                                }> | null;
                            }>;
                        }>;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    };
                    readonly " $fragmentRefs": FragmentRefs<"ChromeDayPicker_org" | "FeedScheduler_org">;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "ChromeDay_viewer";
};
export type ChromeDay_viewer$data = ChromeDay_viewer;
export type ChromeDay_viewer$key = {
    readonly " $data"?: ChromeDay_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeDay_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v3 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v4 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v6 = [
        (v5 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v9 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarIds"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "dates"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "weekStartDates"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "ChromeDay_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "givenName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emails",
                        "storageKey": null
                    },
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000000
                            }
                        ],
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "experiments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryOrgEmail",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "eventColoringSettingsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    (v1 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventCategoryColoring",
                                                                "kind": "LinkedField",
                                                                "name": "eventCategoryColorings",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "active",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "eventCategory",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "googleColorKey",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "isUserSet",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "EventColoringSettings",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "resolveOverrides",
                                                        "value": false
                                                    }
                                                ],
                                                "concreteType": "UserWorkingHours",
                                                "kind": "LinkedField",
                                                "name": "userWorkingHours",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WorkingHours",
                                                        "kind": "LinkedField",
                                                        "name": "workingHours",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "type",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "timeZone",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "DaySetting",
                                                                "kind": "LinkedField",
                                                                "name": "daySettings",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "day",
                                                                        "storageKey": null
                                                                    },
                                                                    (v2 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "DayOverride",
                                                                "kind": "LinkedField",
                                                                "name": "dayOverrides",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "date",
                                                                        "storageKey": null
                                                                    },
                                                                    (v2 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": "userWorkingHours(resolveOverrides:false)"
                                            },
                                            {
                                                "alias": null,
                                                "args": [
                                                    (v3 /*: any*/),
                                                    {
                                                        "kind": "Variable",
                                                        "name": "dates",
                                                        "variableName": "dates"
                                                    },
                                                    (v4 /*: any*/)
                                                ],
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "calendarTimeStatsList",
                                                "plural": false,
                                                "selections": [
                                                    (v1 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CalendarTimeStats",
                                                                "kind": "LinkedField",
                                                                "name": "list",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "calendarId",
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "CalendarFocusTimeScore",
                                                                        "kind": "LinkedField",
                                                                        "name": "scoresByDate",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "secondaryKey",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "busyMinutes",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "focusMinutes",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "totalMinutes",
                                                                                "storageKey": null
                                                                            },
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "crawledStatus",
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "CalendarTimeStatsList",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": [
                                                    (v3 /*: any*/),
                                                    {
                                                        "kind": "Literal",
                                                        "name": "includeAllDay",
                                                        "value": true
                                                    },
                                                    (v4 /*: any*/),
                                                    {
                                                        "kind": "Variable",
                                                        "name": "weekStartDates",
                                                        "variableName": "weekStartDates"
                                                    }
                                                ],
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "eventParentBaseWrapperByWeeksObject",
                                                "plural": false,
                                                "selections": [
                                                    (v1 /*: any*/),
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventParentBaseWrapperByWeekObject",
                                                                "kind": "LinkedField",
                                                                "name": "list",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "EventParentBase",
                                                                        "kind": "LinkedField",
                                                                        "name": "eventParentBases",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            (v0 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "kind": "ScalarField",
                                                                                "name": "timestamp",
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "EventParentsForDay",
                                                                        "kind": "LinkedField",
                                                                        "name": "eventParentsByDay",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "EventParent",
                                                                                "kind": "LinkedField",
                                                                                "name": "eventParents",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    (v0 /*: any*/),
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "eventParentBaseId",
                                                                                        "storageKey": null
                                                                                    },
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "kind": "ScalarField",
                                                                                        "name": "eventParentBaseTimestamp",
                                                                                        "storageKey": null
                                                                                    },
                                                                                    {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "Event",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "events",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "title",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "locked",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "isClockwiseEvent",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "isAllDay",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "calendarIds",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "Attendee",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "organizer",
                                                                                                "plural": false,
                                                                                                "selections": (v6 /*: any*/),
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "Attendee",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "attendees",
                                                                                                "plural": true,
                                                                                                "selections": (v6 /*: any*/),
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "Attendee",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "creator",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    (v5 /*: any*/)
                                                                                                ],
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "AnnotatedEvent",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "annotatedEvent",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "concreteType": "UserTag",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "userTags",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            (v7 /*: any*/),
                                                                                                            {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "TagState",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "states",
                                                                                                                "plural": true,
                                                                                                                "selections": (v8 /*: any*/),
                                                                                                                "storageKey": null
                                                                                                            }
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                    },
                                                                                                    {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "concreteType": "OrgTag",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "orgTags",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            (v7 /*: any*/),
                                                                                                            {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "TagState",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "state",
                                                                                                                "plural": false,
                                                                                                                "selections": (v8 /*: any*/),
                                                                                                                "storageKey": null
                                                                                                            }
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                    }
                                                                                                ],
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "EventKey",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "eventKey",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "externalEventId",
                                                                                                        "storageKey": null
                                                                                                    }
                                                                                                ],
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "kind": "ScalarField",
                                                                                                "name": "location",
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "EventTime",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "startTime",
                                                                                                "plural": false,
                                                                                                "selections": (v9 /*: any*/),
                                                                                                "storageKey": null
                                                                                            },
                                                                                            {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "EventTime",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "endTime",
                                                                                                "plural": false,
                                                                                                "selections": (v9 /*: any*/),
                                                                                                "storageKey": null
                                                                                            }
                                                                                        ],
                                                                                        "storageKey": null
                                                                                    }
                                                                                ],
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "EventParentBaseWrapperByWeekObjectList",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "ChromeDayPicker_org"
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "FeedScheduler_org"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '637d797261145366d57b89f0898a9d36';
export default node;
